import React, { ReactElement } from "react";
import { Grid, Divider, Typography, Link, Box } from "@mui/material";
import "./index.css";
import WorkRequestsTable from "./WorkRequestsTable";
import MySamplesTable from "./MySamplesTable";
import RecentTestResultsTable from "./RecentTestResultsTable";
import RecentlyUsedBlendStudiesTable from "./RecentlyUsedBlendStudiesTable";
import { Link as RouterLink } from "react-router-dom";
import { usePreferences } from "../../context/PreferencesContext";
import AuthGate from "../../routing/components/AuthGate";
import { Roles } from "../../constants/roles";
import { HelpTab } from "../Help";

function SetBannerImage() {
  let todayDate = new Date();
  let day = todayDate.getDate();
  let month = todayDate.getMonth();
  let rnd = Math.random();

  if (month === 9 && day === 31) {
    return "homebannerHalloween";
  } else if (month === 0 && day === 1) {
    return "homebannerNewYearsDay";
  } else if (month === 10 && day === 24) {
    return "homebannerThanksgiving";
  } else if (month === 2 && day === 14) {
    return "homebannerPiDay";
  } else if (month === 11 && day >= 20 && day <= 30) {
    return "homebannerChristmas";
  } else if (month === 2 && day === 17) {
    return "homebannerStPatricksDay";
  } else if (month === 11 && Math.random() > 0.8) {
    return "homebannerDecember";
  } else if (month === 0 && Math.random() > 0.8) {
    return "homebannerWinter1";
  } else if (month === 2 && Math.random() > 0.8) {
    return "homebannerEarlySpring";
  } else if (month === 10 && Math.random() > 0.8) {
    return "homebannerNovember";
  } else if (rnd < 0.05) {
    return "homebannerBabyG";
  } else if (rnd >= 0.05 && rnd < 0.1) {
    return "homebannerPunchCard";
  } else {
    return "homebanner";
  }
}

const Home = (): ReactElement => {
  const { userPreferences } = usePreferences();

  const renderWidgets = () => {
    let widgetArray: (JSX.Element | undefined)[] = [];

    const returnCorrectComponent = (keyName: string): JSX.Element | undefined => {
      switch (keyName) {
        case "showRecentSamplesWidget":
          return (
            <AuthGate>
              <Grid item xs={6}>
                <Typography className="homeTableHeader" variant="h6" component="div">
                  My Recent Samples
                </Typography>
                <MySamplesTable />
              </Grid>
            </AuthGate>
          );
        case "showRecentTestsWidget":
          return (
            <AuthGate>
              <Grid item xs={6}>
                <Typography className="homeTableHeader" variant="h6" component="div">
                  My Recent Test Submissions
                </Typography>
                <RecentTestResultsTable />
              </Grid>
            </AuthGate>
          );
        case "showWorkRequestWidget":
          return (
            <AuthGate>
              <Grid item xs={6}>
                <Typography className="homeTableHeader" variant="h6" component="div">
                  My Recent Work Requests
                </Typography>
                <WorkRequestsTable />
              </Grid>
            </AuthGate>
          );
        case "showRecentBlendsWidget":
          return (
            <AuthGate>
              <Grid item xs={6}>
                <Typography className="homeTableHeader" variant="h6" component="div">
                  My Recent Blend Studies
                </Typography>
                <RecentlyUsedBlendStudiesTable />
              </Grid>
            </AuthGate>
          );
        default:
          break;
      }
    };

    Object.entries(userPreferences).forEach(([key, value]) => {
      if (key?.includes("Widget") && value) {
        const component = returnCorrectComponent(key);
        widgetArray.push(component);
      }
    });

    return (
      <Grid container spacing={3} className="homeTables">
        {widgetArray.map((widget, index) => {
          return <React.Fragment key={index}>{widget}</React.Fragment>;
        })}
      </Grid>
    );
  };

  return (
    <Box display="flex" flexDirection="column">
      <span className="pageheader">Home</span>
      <Divider className="dividerbar" />
      {"Welcome to MIDAS3!  "}
      <br />

      <AuthGate>
        <MidasManualLink />
      </AuthGate>

      <AuthGate restrictedToRoles={[Roles.MidasGuest]}>
        <GuestOnBoarding />
      </AuthGate>

      {/* <TempWelcomeBanner></TempWelcomeBanner> */}
      <div className={SetBannerImage()}>
        <Grid container spacing={2} style={{ height: "13rem" }}></Grid>
      </div>
      {renderWidgets()}
    </Box>
  );
};

const MidasManualLink = () => {
  var link = (
    <Link style={{fontWeight: "bold"}} href="http://goto/MidasManual" target="_blank" rel="noopener noreferrer">
      Midas Instructions Manual
    </Link>
  );
  return (
    <Box display="flex" gap={0.5}>
      For training and instruction, please see the {link} goto/MidasManual
    </Box>
  );
};

const GuestOnBoarding = () => {
  var link = (
    <RouterLink
      className="homepagehyperlinks"
      to={{ pathname: `/help`, state: { tabValue: HelpTab.GuestOnBoarding } }}>
      here
    </RouterLink>
  );
  return (
    <Box display="flex" gap={0.5}>
      Click {link} for guidance on guest user onboarding.
    </Box>
  );
};

export default Home;
